
import { trigger, state, animate, transition, style } from '@angular/animations';


export const fadeInOut = trigger('routeAnimation', [			
    transition(':enter', [  // before 2.1: transition('void => *', [
        style({opacity: '0'}),
    animate('1.5s ease-in-out', style({opacity: '1'}))
    ]),
    transition(':leave', [  // before 2.1: transition('* => void', [
        style({opacity: '1'}),
    animate('1.5s ease-in-out', style({opacity: '0'}))
    ])
]);

export const fadeInOutAnimation = trigger('fadeInOutAnim', [
    state('initial', style({ opacity: '0' })),
    state('final', style({ opacity: '1' })),
    transition('initial=>final', animate('0.5s ease-in-out')),
    transition('final=>initial', animate('0.5s ease-in-out'))
]);
